module.exports = __webpack_public_path__ + "img/fail.25bc8bc4.png";